import React from "react";
import SideEffects from "./side-effects";

// Form B Q5 (Yes branch) — the "symptom + severity + current/resolved status"
// module the doc describes. Reached only after answering "Yes" at the gate
// (current-side-effects.jsx), so there's no "None of the below" option here.
export default function CurrentSideEffectsModule(props) {
  return (
    <SideEffects
      {...props}
      nextStepId="b6"
      includeNoneOption={false}
      showResolvedStatus={true}
      title="Tell us about your side effects"
    />
  );
}
